import React from "react"
import { createRoot } from "react-dom/client"

import App from "~/App"
import "~/translations"

if (CONFIG.isDevelopment) {
	import("react-scan").then(({ scan }) => {
		scan({ enabled: true })
	})
} else {
	import("@sentry/react").then(Sentry => {
		Sentry.init({
			dsn: "https://9d8352e4606c4d6f96cb219abec7af08@o794413.ingest.sentry.io/5894396",
			replaysOnErrorSampleRate: 0.25,
			tracesSampleRate: 0.05,
			integrations: [
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration({
					beforeErrorSampling(event) {
						const error = event.exception?.values?.[0].value
						if (error?.includes("Failed to fetch")) return false
						return true
					},
				}),
			],
		})
	})
}

document.addEventListener("DOMContentLoaded", () => {
	createRoot(document.getElementById("root")!).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	)
})
